<template>
  <div class="alert alert-warning p-5">
    <h3>{{ title }}</h3>
    <p> {{ message }} </p>

    <p class="">
      If you require assistance please contact
      <a
        class="text-primary font-weight-bold"
        :href="
          industry == 'cannabis'
            ? 'mailto:support@apextrading.com?subject=Technical Support Request for Apex Trading'
            : 'mailto:support@bushel44.com?subject=Technical Support Request for Bushel44'
        "
      >{{ appName }}</a>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, required: true },
    message: { type: String, required: true },
  },
  data() {
    return {
            appName: APP_NAME,  
            industry: APP_INDUSTRY,  
    };
  },
};
</script>
